import Button from '@klv/atoms/button';

import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/buttons.module.css';

import type { TVariantOptions } from '@klv/atoms/button/types';
import type { IButtons } from './types';

// fill an array to fit the length provided with values from the first index
const padArray = (variants: TVariantOptions[], length: number) => {
  const newArray = [...variants];
  do {
    newArray.push(newArray[0]);
  } while (newArray.length < length);

  return newArray;
};

const Buttons = ({
  buttonColor,
  buttons = [],
  className,
  setTabIndex = 0,
  variants,
  ...props
}: IButtons) => {
  if (buttons?.length > 0) {
    const variantArray = padArray(variants, buttons.length);

    return (
      <div className={generateClassName([className, styles.buttonContainer])} {...props}>
        {buttons.map((button, index) => (
          <Button
            {...button}
            key={button.text}
            buttonColor={buttonColor}
            setTabIndex={setTabIndex}
            variant={variantArray[index]}
          />
        ))}
      </div>
    );
  }

  return null;
};

export default Buttons;
